import React from "react";
import { SealCheck } from "@phosphor-icons/react";

const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const fmt = (iso) => (iso ? new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");

// Prepaid (Pay & Book) settlement: prepaid details, remaining payment and total due.
export function PrepaidSettlement({ prepaid, total, dark = false, testid = "prepaid-settlement" }) {
  if (!prepaid) return null;
  const paid = Number(prepaid.amount || 0);
  const t = Number(total || 0);
  const due = Math.max(t - paid, 0);
  const muted = dark ? "text-white/60" : "text-[#8A8780]";
  const box = dark ? "bg-white/10 border-white/15" : "bg-[#E8F3E5] border-[#C7E0C2]";
  return (
    <div className={`mt-2 rounded-md border p-2.5 text-[12px] space-y-1 ${box}`} data-testid={testid}>
      <div className={`flex items-center gap-1.5 font-semibold ${dark ? "text-[#C7E0C2]" : "text-[#2D5A27]"}`}>
        <SealCheck size={13} weight="fill"/> Prepaid at booking
      </div>
      <div className="flex justify-between"><span className={muted}>Prepaid amount</span><span className="font-mono" data-testid={`${testid}-amount`}>− {inr(paid)}</span></div>
      <div className="flex justify-between"><span className={muted}>Payment date</span><span className="font-mono" data-testid={`${testid}-date`}>{fmt(prepaid.paid_at)}</span></div>
      <div className="flex justify-between gap-2"><span className={muted}>Payment ID</span><span className="font-mono truncate" data-testid={`${testid}-id`}>{prepaid.payment_id || "—"} · {prepaid.source}</span></div>
      <div className={`flex justify-between pt-1 border-t ${dark ? "border-white/15" : "border-[#C7E0C2]"}`}>
        <span className={muted}>Remaining payment</span><span className="font-mono" data-testid={`${testid}-remaining`}>{inr(due)}</span>
      </div>
      <div className="flex justify-between font-semibold text-[13px]">
        <span>Total due</span>
        <span className="font-mono" data-testid={`${testid}-due`}>{due > 0 ? inr(due) : "₹0.00 · Fully paid"}</span>
      </div>
      {due > 0 && <div className={`text-[10px] ${muted}`}>Partial prepayment — a balance payment link will be sent for {inr(due)}.</div>}
    </div>
  );
}
